<div class="devices-filter-bg"></div>
<div class="devices-filter-container flex flex-col gap-8 overflow-auto">
    <!-- titulo del filtro -->
    <section class="flex flex-col gap-2">
        <div class="flex gap-2 items-center">
            <svg class="w-6 h-6 fill-neutral-600"  width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66745 7.16716H6.49127C6.85123 8.49159 8.21669 9.27345 9.54113 8.91349C10.3918 8.68229 11.0563 8.0178 11.2875 7.16716H19.3327C19.7008 7.16716 19.9993 6.86872 19.9993 6.50057C19.9993 6.13242 19.7008 5.83398 19.3327 5.83398H11.2875C10.9275 4.50951 9.56203 3.72765 8.2376 4.08762C7.38696 4.31881 6.72246 4.98331 6.49127 5.83395H4.66745C4.29929 5.83395 4.00085 6.13239 4.00085 6.50054C4.00085 6.86869 4.29929 7.16716 4.66745 7.16716Z"/>
                <path d="M19.3327 11.3334H17.5088C17.1496 10.0092 15.7849 9.22686 14.4606 9.58608C13.6093 9.81703 12.9443 10.4821 12.7133 11.3334H4.66745C4.29929 11.3334 4.00085 11.6318 4.00085 12C4.00085 12.3682 4.29929 12.6666 4.66745 12.6666H12.7133C13.0726 13.9908 14.4373 14.7731 15.7615 14.4139C16.6128 14.183 17.2779 13.5179 17.5088 12.6666H19.3327C19.7008 12.6666 19.9993 12.3682 19.9993 12C19.9993 11.6318 19.7008 11.3334 19.3327 11.3334Z"/>
                <path d="M19.3327 16.8329H11.2875C10.9275 15.5084 9.56203 14.7266 8.2376 15.0865C7.38696 15.3177 6.72246 15.9822 6.49127 16.8329H4.66745C4.29929 16.8329 4.00085 17.1313 4.00085 17.4995C4.00085 17.8676 4.29929 18.1661 4.66745 18.1661H6.49127C6.85123 19.4905 8.21669 20.2723 9.54113 19.9124C10.3918 19.6812 11.0563 19.0167 11.2875 18.1661H19.3327C19.7008 18.1661 19.9993 17.8676 19.9993 17.4995C19.9993 17.1313 19.7008 16.8329 19.3327 16.8329Z"/>
            </svg>
            <span class="text-neutral-600 text-2xl font-['Inter']">
                Filtros
            </span>
            <button class="ml-auto" type="button" title="Cerrar filtro" (click)="close()">
                <img class="w-6 h-6" src="../../../assets/img/devices/ic-close.svg" />
            </button>
        </div>
        <span class="text-neutral-600 text-xs font-['Inter']">
            Los cambios se aplican y guardan automáticamente
        </span>
    </section>

    <!-- filtros -->
    <form class="flex flex-col gap-4" [formGroup]="form">
        <hr />
        <div class="flex flex-col">
            <button class="w-full h-[32px] flex justify-between items-center" [class.active]="filtroEstadoVisible" (click)="filtroEstadoVisible = !filtroEstadoVisible">
                <span class="font-['Inter'] text-neutral-600 text-base font-medium">
                    Estado
                </span>
                @if(filtroEstadoVisible) {
                    <img class="w-6 h-6" src="../../../assets/img/devices/ic-angle-up.svg" />
                } @else {
                    <img class="w-6 h-6" src="../../../assets/img/devices/ic-angle-down.svg" />
                }
            </button>
            <div 
                class="category-filter-container overflow-hidden" 
                [ngClass]="filtroEstadoVisible ? 'mt-[10px] max-h-40 opacity-100' : 'max-h-0 opacity-0'"
                formGroupName="estado"
                >

                <label class="checkbox-container">
                    <span class="checkbox-label">
                        Todos
                    </span>
                    <input type="checkbox" formControlName="todos">
                    <span class="checkmark"></span>
                </label>

                <label class="checkbox-container">
                    <span class="checkbox-label">
                        Habilitado
                    </span>
                    <input type="checkbox" formControlName="habilitado">
                    <span class="checkmark"></span>
                </label>

                <label class="checkbox-container">
                    <span class="checkbox-label">
                        Deshabilitado
                    </span>
                    <input type="checkbox" formControlName="deshabilitado">
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
        <hr />
        <div class="flex flex-col">
            <button class="w-full h-[32px] flex justify-between items-center" [class.active]="filtroTipoVisible" (click)="filtroTipoVisible = !filtroTipoVisible">
                <span class=" font-['Inter'] text-neutral-600 text-base font-medium">
                    Tipo
                </span>
                @if(filtroTipoVisible) {
                    <img class="w-6 h-6" src="../../../assets/img/devices/ic-angle-up.svg" />
                } @else {
                    <img class="w-6 h-6" src="../../../assets/img/devices/ic-angle-down.svg" />
                }
            </button>
            <div 
                class="category-filter-container overflow-hidden" 
                [ngClass]="filtroTipoVisible ? 'mt-[10px] max-h-40 opacity-100' : 'max-h-0 opacity-0'"
                formGroupName="tipo"
                >
                
                <label class="checkbox-container">
                    <span class="checkbox-label">
                        Todos
                    </span>
                    <input type="checkbox" formControlName="todos">
                    <span class="checkmark"></span>
                </label>

                <label class="checkbox-container">
                    <span class="checkbox-label">
                        SmartPOS
                    </span>
                    <input type="checkbox" formControlName="smartPOS">
                    <span class="checkmark"></span>
                </label>

                <label class="checkbox-container">
                    <span class="checkbox-label">
                        SoftPOS
                    </span>
                    <input type="checkbox" formControlName="softPOS">
                    <span class="checkmark"></span>
                </label>

            </div>
        </div>
        <hr />
        <div class="flex flex-col">
            <button class="w-full h-[32px] flex justify-between items-center" [class.active]="filtroComercioVisible" (click)="filtroComercioVisible = !filtroComercioVisible">
                <span class=" font-['Inter'] text-neutral-600 text-base font-medium">
                    Comercio
                </span>
                @if(filtroComercioVisible) {
                    <img class="w-6 h-6" src="../../../assets/img/devices/ic-angle-up.svg" />
                } @else {
                    <img class="w-6 h-6" src="../../../assets/img/devices/ic-angle-down.svg" />
                }
            </button>
            <div 
                class="category-filter-container overflow-auto" 
                [ngClass]="filtroComercioVisible ? 'mt-[10px] max-h-40 opacity-100' : 'max-h-0 opacity-0'"
                formGroupName="comercio"
                >

                <label class="checkbox-container">
                    <span class="checkbox-label">
                        Todos
                    </span>
                    <input type="checkbox" formControlName="todos">
                    <span class="checkmark"></span>
                </label>

                @for (comercio of comercioControls; track $index) {
                    <label class="checkbox-container">
                        <span class="checkbox-label">
                            {{comercio}}
                        </span>
                        <input type="checkbox" [formControlName]="comercio">
                        <span class="checkmark"></span>
                    </label>
                }
            </div>
        </div>
        <hr />
        <div class="flex flex-col">
            <button class="w-full h-[32px] flex justify-between items-center" [class.active]="filtroDispositivoVisible" (click)="filtroDispositivoVisible = !filtroDispositivoVisible">
                <span class=" font-['Inter'] text-neutral-600 text-base font-medium">
                    Dispositivo
                </span>
                @if(filtroDispositivoVisible) {
                    <img class="w-6 h-6" src="../../../assets/img/devices/ic-angle-up.svg" />
                } @else {
                    <img class="w-6 h-6" src="../../../assets/img/devices/ic-angle-down.svg" />
                }
            </button>
            <div 
                class="category-filter-container overflow-auto" 
                [ngClass]="filtroDispositivoVisible ? 'mt-[10px] max-h-40 opacity-100' : 'max-h-0 opacity-0'"
                formGroupName="dispositivo"
                >
                
                <label class="checkbox-container">
                    <span class="checkbox-label">
                        Todos
                    </span>
                    <input type="checkbox" formControlName="todos">
                    <span class="checkmark"></span>
                </label>

                @for (dispositivo of dispositivoControls; track $index) {
                    <label class="checkbox-container">
                        <span class="checkbox-label">
                            {{dispositivo}}
                        </span>
                        <input type="checkbox" [formControlName]="dispositivo">
                        <span class="checkmark"></span>
                    </label>
                }
            </div>
        </div>
        <hr />
    </form>

    <!-- limpiar filtros -->
    <section class="text-center">
        <button class="flex gap-2 mx-auto" type="button" title="Limpiar filtros" (click)="clear()">
            <img class="w-6 h-6" alt="icono limpiar filtro" src="../../../assets/img/devices/ic-clear-filter.svg" />
            <span class="font-['Inter'] font-semibold text-base text-neutral-600">Limpiar Filtros</span>
        </button>
    </section>

</div>